var monthNames = ["January", "February", "March", "April", "May", "June",
			   "July", "August", "September", "October", "November", "December"];

var selectedCity;
var selectedMonthYear;

$(document).ready(function () {
	BindElements();
	setCurrentMonthYear();
	///$('#events-list').liveFilter('#category-filter-dropdown', 'li', {
	//  filterChildSelector: 'a'
	//});

	// Resize the Events list titles so they're all the same and the CTA buttons line up nicely
	$("#events-list .module").each(function (index, element) {
		equalHeight($(".module-title", this));
	});

});

$(document).on('click', '#category-filter-dropdown li a', function () {
	selectedCity = $(this).text()
	//console.log("Selected Option:" + selectedCity);
	$("#selected-city-filter").attr('data-selected-city-filter', selectedCity);
	$("#selected-city-filter").html("Category (" + selectedCity + ")");
	//alert($("#selected-city-filter").data("selected-city-filter"));

	applyEventFilter();
});


function applyEventFilter() {
	var selectedCity = $("#selected-city-filter").attr('data-selected-city-filter'); //$("#selected-city-filter").data("selected-city-filter");
	var selectedMonthYear = $('#monthpicker-input').val();

	if (selectedCity != "All") {				//Slide up events list, sort out the items to be displayed then slide down :)
		$("div#events-list").slideUp("slow", function () {
			$("div#events-list  div.module-container:not([data-city='" + selectedCity + "'])").hide();
			$("div#events-list  div.module-container:not([data-month-year='" + selectedMonthYear + "'])").hide();
			$("div#events-list div.module-container[data-city='All']").show();

			$("div#events-list div.module-container[data-month-year='" + selectedMonthYear + "'][data-city='" + selectedCity + "'], [data-month-year='All']").show(function () {
				$("div#events-list").slideDown("slow", function () {
				});

			});

		});
	}
	else {
		//Show all locations for selected Month Year
		$("div#events-list").slideUp("slow", function () {
			$("div#events-list  div.module-container").show();
			$("div#events-list div.module-container[data-city='All']").show();
			$("div#events-list  div.module-container:not([data-month-year='" + selectedMonthYear + "'])").hide();
			$("div#events-list div.module-container[data-month-year='All']").show();

			$("div#events-list div.module-container[data-month-year='" + selectedMonthYear + "'], [data-month-year='All']").show(function () {
				$("div#events-list").slideDown("slow");
			});

			//Show no Events Message if visible count is 0
			if ($("div#events-list div.module-container[data-month-year='" + selectedMonthYear + "']").length == 0) {
				$("div#events-list").slideDown("slow", function () {
					$('#no-events').fadeIn();
				});
			}
			else {
				$('#no-events').hide();
			};

		});
	}



}

function setCurrentMonthYear() {
	var todaysDate = new Date();
	//format the date in the right format (add 1 to month because JavaScript counts from 0)
	//formatDate = (todaysDate.getMonth() + 1) + '/' + 
	//                todaysDate.getDate() + '/' + 
	//               todaysDate.getFullYear();

	$('#monthpicker-input').val(monthNames[todaysDate.getMonth()] + ' ' + todaysDate.getFullYear());
	applyEventFilter();
}


function BindElements() {
	//$('.dropdown').dropkick();

	$('[rel="datetime"]').datepicker({
		autoClose: true,
		dateFormat: "dd/mm/yy",
		changeYear: true,
		changeMonth: true,
		beforeShow: function (input, inst) {
			$(inst).css("z-index", "1060");
		}
	});
	$('input[rel="datetime"]').keypress(function (e) {
		return false;
	});
	$('input[rel="datetime"]').keydown(function (e) {
		if (e.keyCode != 46 && e.keyCode != 8)
			return false;

		$(e.currentTarget).val("");
		e.stopPropagation();
		e.preventDefault();
		return false;
	});
	$('.monthpicker').datepicker({
		"format": "MM yyyy",
		'startView': 1,
		'minViewMode': 1
	}).on('changeMonth', function (e) {
		var dp = $(e.currentTarget).data('datepicker');
		dp.date = e.date;
		dp.setValue();
		dp.hide();
		applyEventFilter();
	});
	$('.monthpicker').keypress(function (e) {
		return false;
	});
	$('.monthpicker').keydown(function (e) {
		if (e.keyCode != 46 && e.keyCode != 8)
			return false;

		$(e.currentTarget).val("");
		e.stopPropagation();
		e.preventDefault();
		return false;
	});

	$('.yearpicker').datepicker({
		"format": "yyyy",
		'startView': 2
	}).on('changeYear', function (e) {
		var dp = $(e.currentTarget).data('datepicker');
		dp.date = e.date;
		dp.setValue();
		dp.hide();
	});

	//$('.dropdown-toggle').dropdown()

}


// Three Column Buttons Actions
$("span.3-col-grid").click(function () {
	$("#events-list .module-container").removeClass("sixteen columns").addClass("one-third column");
	//$("#events-list .module-header").removeClass("twelve columns alpha");
	//$("#events-list .module-header").fadeIn();
	$('#events-list .show-in-list').fadeOut();
	$('.module-content').css('text-align', 'center');
	$("#events-list .module-meta").fadeOut(100).removeClass("one-third column alpha omega visible");
	$(".grid_btn").addClass("list_btn_active");
	$(".list_btn").removeClass("list_btn_active");

	$(".day-text-overlay").removeClass("list");
	$(".event-month-text").removeClass("list");
	$(".event-day-container").removeClass("list");
	$(".event-month-container").removeClass("list");

	$(".module-header").removeClass("three columns");
	$(".module-content").removeClass("seven columns");
	$(".module-cta-container").removeClass("two columns");

});

$("span.3-col-list").click(function () {
	$("#events-list .module-container").removeClass("one-third column").addClass("sixteen columns");
	//$("#events-list .module-header").addClass("two columns alpha");
	//$("#events-list .module-header").fadeOut();
	$('.module-content').css('text-align', 'left');
	$('#events-list .show-in-list').fadeIn();

	$("#events-list .module-content").fadeIn(300).removeClass("one-third column alpha").addClass("four columns omega visible");
	$(".list_btn").addClass("list_btn_active");
	$(".grid_btn").removeClass("list_btn_active");
	$(".day-text-overlay").addClass("list");
	$(".event-month-text").addClass("list");
	$(".event-day-container").addClass("list");
	$(".event-month-container").addClass("list");

	$(".module-header").addClass("three columns");
	$(".module-content").addClass("seven columns");
	$(".module-cta-container").addClass("three columns");

});

window.hideFlashingCursor = function () {
	$(".monthpicker").blur();
}

function equalHeight(group) {
	var tallest = 0;
	group.each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > tallest) {
			tallest = thisHeight;
		}
		//console.log(tallest);
	});
	group.height(tallest);
}
